export interface IBillingStatementLogPaymentResponseSearchCriteria{
    billingStatementLogIds: Array<string>;
}

export class BillingStatementLogPaymentResponseSearchCriteria implements IBillingStatementLogPaymentResponseSearchCriteria{
    billingStatementLogIds: Array<string>;
}

